<template>

	<Modal 
		:width="500"
		:title="title"
		@close="close"
		:loading="loading"
	>

		<template v-slot:content>

			<form class="form" @submit.prevent="saveDate">

				<p v-if="dates.length>=max" class="error-message">You can only have up to {{ max }} custom date columns, please delete one before adding a new one.</p>

				<div class="form-group" v-if="dates.length<max">
					<div class="input-wrap">
						<DateFilter
							@change="changeDate"
							@clear="changeDate"
							mode="single"
							:placeholder="dates.length > 0 ? 'Add another date' : 'Add a date'"
							:value="theDate"
							:key="dateFilterKey"
						/>
					</div>
					<div class="button-wrap">
						<span class="large-button mini" v-if="theDate" @click="saveDate">Save</span>
					</div>
				</div>

				<div class="current-dates" v-if="dates.length>0">
					<h3>Current Dates</h3>
					
					<div class="date-list">
						<div class="date-item" v-for="date in dates" :key="date._id">
							<span class="label">{{ date.customDate }}</span>
							<button type="button" class="delete-btn" @click="deleteDate(date._id)">×</button>
						</div>
					</div>
				</div>
			</form>

		</template>

	</Modal>

</template>

<script>
import ApiService from './../../services/api.service'
import general from './../../utils/general'
import Modal from './Modal.vue'
import DateFilter from './../Data/DateFilter.vue'
export default {
	name: 'RankingsCustomDate',
	components: { Modal, DateFilter },
	props: {
		projectId: String
	},
	data() {

		return {
			tag: '',
			tags: [],
			inputFocus: false,
			inputWrapFocus: false,
			errorMessage: '',
			needsUpdate: false,
			theDate: null,
			loading: '',
			dates: [],
			max: 5,
			dateFilterKey: 0
		}

	},
	watch: {
	},
	
	computed: { 
		buttonText () {

			return 'Save Changes';

		},

		title () {

			return 'Custom Date Columns';

		}

    },

	methods: {

		changeDate (info) {

			this.theDate = info

		},

		saveDate () {

			this.loading = 'Saving, this could take a moment as we update your keywords';

			ApiService.post( `keywords/custom-date/${this.projectId}`, { date: this.theDate } )
				.then( function( info ) {

					this.loading = '';

					this.dates = info.data.list;

					this.theDate = null;

					this.$emit('added',info.data.heading);

					this.$snotify.success('Date added');

					this.dateFilterKey++;

				}.bind(this))
				.catch( function(a,b) {
					this.loading = '';
					general.$snotify (this,'error','Error',a);
				}.bind(this));

		},

		deleteDate (id) {

			this.$dialog
				.confirm( "Are you sure you want to delete this date?", { okText: 'Yes', cancelText: 'Cancel',})
				.then(function() {

						ApiService.delete( `keywords/custom-date/${this.projectId}/${id}` )
						.then( function( info ) {

							this.dates = info.data;

							this.$emit('added','');

							this.dateFilterKey++;

						}.bind(this));

				}.bind(this))
				.catch(function() {});

		},

		getDates () {

			ApiService.get( `keywords/custom-date/${this.projectId}` )
				.then( function( info ) {

					this.loading = '';

					this.dates = info.data;

				}.bind(this));

		},

		close(save) {

			this.$emit('close');

		}
	},
	created() {

		this.getDates();

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';

.form {
	min-height: 350px;

	.form-group {
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 20px;

		label {
			display: block;
			margin-bottom: 8px;
			font-weight: 500;
		}

		.input-wrap {
			flex: 1;
		}

		.button-wrap {
			flex: 0 0 50px;
			.large-button {
				width: 100%;
				margin: 0;
			}	
		}
	}
	.error-message {
		padding: 0;
		margin: 0;
		text-align: left;
		color: @red;
	}
}

.current-dates {
	margin-top: 30px;

	h3 {
		margin-bottom: 15px;
		font-size: 16px;
		font-weight: 500;
	}

	.date-list {
		.date-item {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 10px;
			padding: 10px 15px;
			background-color: @bgGrey;
			border-radius: 6px;
			transition: background-color 0.2s ease;

			.label {
				color: @darkContrast;
			}

			.delete-btn {
				padding: 0;
				width: 24px;
				height: 24px;
				border: none;
				border-radius: 50%;
				background-color: @darkContrast;
				color: #fff;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 16px;
				transition: all 0.2s ease;
				opacity: 0.8;
				&:hover {
					opacity: 1;
				}
			}
		}
	}
}

@media screen and (min-width: 768px) {
	.form {
		
	}
}
</style>